export default class Yandex {
    static metrika = (method, target, counterId = process.env.VUE_APP_YANDEX_COUNTER_ID) => {
        if (!window.ym) {
            console.debug('Отсутствует метод яндекс метрики')
            return
        }

        window.ym(counterId, method, target)
    }
}